import { createContext } from 'react';
import { IAppointmentChat, IChat, IIncomingMessage } from '../components/Chat/Chat';

export type InitialVideochatType = {
    incomingCall: boolean;
    callAccepted: boolean;
    caller: string;
    remoteSid: string;
    roomName: string;
    localStream: any;
    remoteStream: any;
    iceServer: Array<string>;
    chatMessages: IIncomingMessage[];
    chatMessagesLoaded: boolean;
    numberUnreadMessages: number;
    lastIncomingTextChatMsg: string;
    appointmentChat: IAppointmentChat[];
    lastIncomingAppChatMsg: IChat;
    audioMuted: boolean;
    jitsiAllowed: boolean;
    jitsiError: string;
    mySid: string;
};

export const initialVideochatState = {
    incomingCall: false,
    callAccepted: false,
    caller: '',
    remoteSid: '',
    localStream: null,
    remoteStream: null,
    roomName: '',
    iceServer: [],
    chatMessages: [],
    chatMessagesLoaded: false,
    numberUnreadMessages: 0,
    lastIncomingTextChatMsg: '',
    appointmentChat: [],
    lastIncomingAppChatMsg: {
        id: '',
        incomingMessages: [],
    },
    audioMuted: false,
    jitsiAllowed: false,
    jitsiError: '',
    mySid: '',
};

const VideochatContext = createContext<{
    vsstate: InitialVideochatType;
    vsdispatch: React.Dispatch<any>;
}>({
    vsstate: initialVideochatState,
    vsdispatch: () => null,
});

export default VideochatContext;
